// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayout_mainLayout__y0VQ6","innerPage":"AppLayout_innerPage__pizx5"};